import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.common.CREAM};
  color: ${({ theme }) => theme.palette.common.PRIMARY};
  gap: 2px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  height: 40px;
  width: 40px;
`;

export const Top = styled.div`
  background-color: ${({ theme }) => theme.palette.common.PRIMARY};
  color: ${({ theme }) => theme.palette.common.WHITE};
  font-size: 10px;
  text-transform: uppercase;
`;
